import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CollapsibleBoxComponent } from './collapsible-box.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [CollapsibleBoxComponent],
  exports: [CollapsibleBoxComponent]
})
export class CollapsibleBoxModule {}
